import React, { useEffect } from 'react';
import $ from 'jquery';

import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/pagination';
import { Pagination, Navigation, Autoplay } from 'swiper/modules';

import 'slick-carousel';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

import person1 from '../../assets/images/female-profile1-trans.png'
import person2 from '../../assets/images/female-profile2-trans.png'
import person3 from '../../assets/images/female-profile3-trans.png'
import person4 from '../../assets/images/person-1.png'
import person5 from '../../assets/images/person-2.png'


function Testimonials() {

    
      useEffect(() => {
        const interval = setInterval(() => {
          const $slider = $('.testimonial__slider__active');
      
          if ($slider.length > 0 && typeof $slider.slick === 'function') {
            $slider.slick({
              infinite: true,
              slidesToShow: 2,
              slidesToScroll: 1,
              dots: false,
              prevArrow:
                '<button type="button" class="slick-prev slick-arrow"><i class="icofont-long-arrow-left"></i></button>',
              nextArrow:
                '<button type="button" class="slick-next slick-arrow"><i class="icofont-long-arrow-right"></i></button>',
              responsive: [
                { breakpoint: 1367, settings: { slidesToShow: 2 } },
                { breakpoint: 993, settings: { slidesToShow: 2 } },
                { breakpoint: 769, settings: { slidesToShow: 1 } },
                { breakpoint: 321, settings: { slidesToShow: 1 } },
              ],
            });
      
            clearInterval(interval);
          }
        }, 300);
      
        return () => clearInterval(interval); // cleanup
      }, []);
    
      

  return (
    <div>
      
{/* <!-- testmonialarea__section__atart --> */}

<div className="testmonialarea">
            <div className="container">
                <div className="row" data-aos="fade-up">
                    <div className="section__title text-center">
                        <div className="section__title__button">
                            <div className="default__small__button">Testimonials</div>
                        </div>
                        <div className="section__title__heading heading__underline">
                            <h2> What Our <span>Students</span> Say</h2>
                        </div>
                    </div>
                </div>
                <div className="row row__custom__class testimonial__slider__active default__arrow" data-aos="fade-up">
                    <div className="column__custom__class">
                        <div className="single__testimonial__wraper">
                            <div className="single__testimonial__inner">
                                <div className="testimonial__img">
                                    <img loading="lazy"  src={person1} className='rounded' alt="testi"/>
                                    <div className="testimonial__name">
                                        <h6>Renuka</h6>                                    </div>
                                </div>
                                <div className="testimonial__icon">
                                    <i className="icofont-star"></i>
                                    <i className="icofont-star"></i>
                                    <i className="icofont-star"></i>
                                    <i className="icofont-star"></i>
                                    <i className="icofont-star dark__color"></i>
                                </div>
                            </div>

                            <div className="testimonial__content">
                                <p>TradingWhales made the stock market less scary and more exciting. The mentorship was top-notch!</p>
                            </div>


                        </div>
                    </div>
                    <div className="col-xl-6 column__custom__class">
                        <div className="single__testimonial__wraper">
                            <div className="single__testimonial__inner">
                                <div className="testimonial__img">
                                    <img loading="lazy"  src={person5} alt="testi"/>
                                    <div className="testimonial__name">
                                        <h6>Vidhya Sagar</h6>
                                    </div>
                                </div>
                                <div className="testimonial__icon">
                                    <i className="icofont-star"></i>
                                    <i className="icofont-star"></i>
                                    <i className="icofont-star"></i>
                                    <i className="icofont-star"></i>
                                    <i className="icofont-star dark__color"></i>
                                </div>
                            </div>

                            <div className="testimonial__content">
                                <p>Loved the hybrid format. The recorded sessions helped me revise and the live sessions cleared all my doubts. </p>
                            </div>


                        </div>
                    </div>
                    <div className="col-xl-6 column__custom__class">
                        <div className="single__testimonial__wraper">
                            <div className="single__testimonial__inner">
                                <div className="testimonial__img">
                                    <img loading="lazy"  src={person3} className='rounded' alt="testi"/>
                                    <div className="testimonial__name">
                                        <h6>Srinidhi</h6>
                                    </div>
                                </div>
                                <div className="testimonial__icon">
                                    <i className="icofont-star"></i>
                                    <i className="icofont-star"></i>
                                    <i className="icofont-star"></i>
                                    <i className="icofont-star"></i>
                                    <i className="icofont-star dark__color"></i>
                                </div>
                            </div>

                            <div className="testimonial__content">
                                <p>From zero knowledge to confident trading—thank you, TradingWhales!</p>
                            </div>


                        </div>
                    </div>
                    <div className="col-xl-6 column__custom__class">
                        <div className="single__testimonial__wraper">
                            <div className="single__testimonial__inner">
                                <div className="testimonial__img">
                                    <img loading="lazy"  src={person5} alt="testi"/>
                                    <div className="testimonial__name">
                                        <h6>Vishnu</h6>                                    </div>
                                </div>
                                <div className="testimonial__icon">
                                    <i className="icofont-star"></i>
                                    <i className="icofont-star"></i>
                                    <i className="icofont-star"></i>
                                    <i className="icofont-star"></i>
                                    <i className="icofont-star dark__color"></i>
                                </div>
                            </div>

                            <div className="testimonial__content">
                                <p>Loved the hybrid format. The recorded sessions helped me revise and the live sessions cleared all my doubts.</p>
                            </div>


                        </div>
                    </div>
                </div>
            </div>
        </div>
        {/* <!-- testmonialarea__section__end--> */}


    </div>
  )
}

export default Testimonials
